import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit, TemplateRef, inject, output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateItalicDirective } from '@shared/directives/translate-italic.directive';
import { Icons } from '../../base-classes/base-group/constants';

@Component({
  selector: 'custom-dialog-v1',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss'],
  imports: [TranslateItalicDirective, NgTemplateOutlet, TranslateModule, MatDialogContent, MatDialogTitle, NgClass]
})
export class CustomDialogComponent implements OnInit {
  translate = inject(TranslateService);
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<CustomDialogComponent>>(MatDialogRef);

  readonly TEMPLATE_TYPE = TEMPLATE_TYPE;
  readonly Icons = Icons;

  title: string = '';
  translateKeys: Record<string, string>;
  templateType: TEMPLATE_TYPE = TEMPLATE_TYPE.TABLE_VIEW;

  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() tempDialog!: TemplateRef<any>;
  readonly onCloseDialog = output();
  ngOnInit(): void {
    if (this.translate.currentLang === 'bi') {
      this.translateKeys = this.data?.translateKeys || {};
    } else {
      this.title = this.data?.title || this.title;
    }
    this.templateType = this.data?.templateType || TEMPLATE_TYPE.TABLE_VIEW;
  }

  onClose() {
    this.onCloseDialog.emit();
  }
}

export type DialogProps = {
  title: string;
  translateKeys?: Record<string, string>;
  templateType?: TEMPLATE_TYPE;
};

export enum TEMPLATE_TYPE {
  TABLE_VIEW = 'table-view',
  LITE = 'lite',
}
